module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-music.svg?c147c2cc595d17d71e87cb665bd95624";